import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const CompaniesResults = ({ companies, accountType }) => {
  const { t } = useTranslation();
  if (!companies.length) {
    return <p className="text-muted text-center py-3">{t('no_companies_found') || 'No companies found'}</p>;
  }
  return (
    <Table hover borderless>
      <tbody>
        {companies.map((company) => (
          <tr key={company.id}>
            <td>
              <Link to={`/${accountType}/companies/${company.id}/overview`} className="fw-semibold text-primary">
                {company.name}
              </Link>
            </td>
            <td className="text-end">
              <Link to={`/${accountType}/companies/${company.id}/edit`} className="text-primary me-4">
                {t('settings') || 'Settings'}
                <span className="material-icons md-18 ms-1" style={{ verticalAlign: 'middle' }}>chevron_right</span>
              </Link>
              <Link to={`/${accountType}/companies/${company.id}/documents`} className="text-primary">
                {t('documents') || 'Documents'}
                <span className="material-icons md-18 ms-1" style={{ verticalAlign: 'middle' }}>chevron_right</span>
              </Link>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default CompaniesResults;
